import * as request from '@/utils/request'

/**
 * 自动生成 api代码【模块名：红人基础数据记录】
 * 生成日期：2025/05/15 15:43:55
 * 生成路径: src/api/kol_basic_record.js
 * 生成人：超级管理员
 */

/**
 * @description 获取列表
 * @param {*} data
 * @returns
 */
export function getKolBasicRecordList(data) {
  return request.post('/kol_basic_record/list', data)
}
export function getKolBasicRecordDeptScope(data) {
  return request.post('/kol_basic_record/dept_scope', data)
}

/**
 * @description 保存
 * @param {*} data
 * @returns
 */
export function saveKolBasicRecord(data) {
  return request.post('/kol_basic_record/store', data)
}

/**
 * 批量保存
 * @param data
 * @returns {Promise}
 */
export function batchSaveKolBasicRecord(data) {
  return request.post('/kol_basic_record/batch_save', { rows:data })
}

/**
 * @description 获取详情
 * @param id
 * @returns
 */
export function getKolBasicRecordInfo(id) {
  let data = { id: id }
  return request.post('/kol_basic_record/get_info', data)
}

/**
 * @description 获取详情
 * @param where
 * @returns
 */
export function queryKolBasicRecordInfo(where) {
  return request.post('/kol_basic_record/query', where)
}

/**
 * @description 根据id删除单条信息
 * @param id
 * @returns
 */
export function deleteKolBasicRecord(id) {
  let data = { id: id }
  return request.post('/kol_basic_record/delete', data)
}

/**
 * 导入
 * @param data
 * @returns {Promise}
 */
export function importKolBasicRecords(data) {
  return request.post('/kol_basic_record/import', data)
}

/**
 * 导出
 * @param data
 * @returns {Promise}
 */
export function exportKolBasicRecords(data) {
  return request.postBlob('/kol_basic_record/export', data)
}

/**
 * 同步红人列表
 * @param data
 * @returns {Promise}
 */
export function syncKolBasicRecords(data) {
  return request.postBlob('/kol_basic_record/sync', data)
}


/**
 * 保存列设置
 * @param data
 * @returns {Promise}
 */
export function saveColsBasicRecords(data) {
  return request.postBlob('/kol_basic_record/save_cols', data)
}

/**
 * 获取列设置
 * @param data
 * @returns {Promise}
 */
export function getColsBasicRecords(data) {
  return request.postBlob('/kol_basic_record/get_cols', data)
}
